/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 付费视频专区
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: Array<cloundtheater.VideoDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/cloundtheater/paid-video-zone`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
